import * as Styles from './LoadingState.styles';

const DEFAULT_COLOR = '#054AD9';

export type LoadingStateProps = {
  /** Optional message displayed below the spinner. */
  message?: string;
  /** Spinner diameter in pixels. Defaults to 36. */
  size?: number;
  /** Spinner color. Defaults to the brand primary. */
  color?: string;
};

const LoadingState = function ({
  message,
  size = 36,
  color = DEFAULT_COLOR,
}: LoadingStateProps): JSX.Element {
  return (
    <Styles.Wrapper>
      <Styles.Spinner $size={size} $color={color} />
      {message && <Styles.Message>{message}</Styles.Message>}
    </Styles.Wrapper>
  );
};

export default LoadingState;
